import React from 'react'
import { Row, Col, Form, Input } from 'antd'
import MemoryStore from '../../../../../utils/memory-store'

import 'brace/mode/json'
import 'brace/theme/xcode'

class ConnectorsFormTypePostgreSQL extends React.Component {
  constructor (props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.disabled = MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'
    this.state = { entry: props.entry || {} }

    // Bindings
    this.onFieldChange = this.onFieldChange.bind(this)
  }

  onFieldChange (key, value) {
    this.entry.custom.isModified = true
    this.props.entry[key] = value
  }

  render () {
    return (
      <Row>
        <Col xs={24} lg={16}>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>
            {'User'}
            <Input
              name='user'
              placeholder='Database user'
              disabled={this.disabled}
              defaultValue={this.state.entry.user}
              onChange={e => {
                this.onFieldChange('user', e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>
            {'Host'}
            <Input
              name='host'
              placeholder='Host'
              disabled={this.disabled}
              defaultValue={this.state.entry.host}
              onChange={e => {
                this.onFieldChange('host', e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>
            {'Database'}
            <Input
              name='database'
              placeholder='Database to connect to'
              disabled={this.disabled}
              defaultValue={this.state.entry.database}
              onChange={e => {
                this.onFieldChange('database', e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item>
            {'Password'}
            <Input
              name='password'
              placeholder='Database password'
              disabled={this.disabled}
              defaultValue={this.state.entry.password}
              autoComplete='new-password'
              type='password'
              onChange={e => {
                this.onFieldChange('password', e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>
            {'Port'}
            <Input
              name='port'
              placeholder='Host URL Port'
              disabled={this.disabled}
              defaultValue={this.state.entry.port}
              onChange={e => {
                this.onFieldChange('port', e.target.value)
              }}
            />
          </Form.Item>
          {/* <div>
            <h3>
              {'Connection Pool Settings'}
            </h3>
            <AceEditor
              showPrintMargin={false}
              readOnly={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              cursorStart={1}
              mode='json'
              theme='xcode'
              style={{ width: '100%', height: 200 }}
              name='aceEditor'
              value={this.state.entry.poolSettings}
              setOptions={{
                showLineNumbers: true,
                newLineMode: 'unix'
              }}
              onChange={value => {
                this.onFieldChange('poolSettings', value)
              }}
            />
          </div> */}
        </Col>
      </Row>
    )
  }
}

export default ConnectorsFormTypePostgreSQL
